
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Compare = lazy(() => import('../pages/compare/page'));
const Referral = lazy(() => import('../pages/referral/page'));
const Professionals = lazy(() => import('../pages/professionals/page'));
const Resources = lazy(() => import('../pages/resources/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Emergency = lazy(() => import('../pages/emergency/page'));
const Insurance = lazy(() => import('../pages/insurance/page'));
const Assessment = lazy(() => import('../pages/assessment/page'));
const Consultation = lazy(() => import('../pages/consultation/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

import Overview from '../pages/overview/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/overview',
    element: <Overview />
  },
  {
    path: '/compare',
    element: <Compare />
  },
  {
    path: '/referral',
    element: <Referral />
  },
  {
    path: '/professionals',
    element: <Professionals />
  },
  {
    path: '/resources',
    element: <Resources />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/emergency',
    element: <Emergency />
  },
  {
    path: '/insurance',
    element: <Insurance />
  },
  {
    path: '/assessment',
    element: <Assessment />
  },
  {
    path: '/consultation',
    element: <Consultation />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
